export const ACCEPTED = 202;
export const BAD_GATEWAY = 502;
export const BAD_REQUEST = 400;
export const CONFLICT = 409;
export const CONTINUE = 100;
export const CREATED = 201;
export const FORBIDDEN = 403;
export const FOUND = 302;
export const GATEWAY_TIMEOUT = 504;
export const GONE = 410;
export const INTERNAL_ERROR = 500;
export const LENGTH_REQUIRED = 411;
export const METHOD_NOT_ALLOWED = 405;
export const MOVED_PERMANENTLY = 301;
export const NO_CONTENT = 204;
export const NOT_ACCEPTABLE = 406;
export const NOT_AUTHORIZED = 401;
export const NOT_FOUND = 404;
export const OK = 200;
export const PARTIAL_CONTENT = 206;
export const PROCESSING = 102;
export const RESET_CONTENT = 205;
export const SERVICE_UNAVAILABLE = 503;
export const SWITCH_PROTOCOLS = 101;
export const TIMEOUT = 408;
export const UNPROCESSABLE_ENTITY = 422;
export const UNSUPPORTED_MEDIA = 415;